export const jabatan_tugas = {
  router: [
    {
      name: "JABATAN TUGAS",
      key: "jabatan_tugas",
      path: "/admin/master/jabatan-tugas",
      apiUrl: {
        data: "master/api/jabatan/tugas/",
        preview: "master/api/jabatan/tugas/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "JABATAN TUGAS",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
